import axios from "axios";
import { GURL } from "./global";

export const RegisterOrLogin = (user: any) => {
  const url = `${GURL}/account/registerOrLogin`;
  const data = axios.post(url, user);
  //console.log(data);
  // localStorage.setItem("token");
  return data;
};

export const SendConfirm = (phoneNumber: any) => {
  const url = `${GURL}/Authentication/v1/Users/RequestVerificationCode`;
  return axios.post(url, { phoneNumber });
};

export const SetPassword = (password: any, passwordConfirm: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const url = `${GURL}/Authentication/v1/Users/SetPassword`;
  return axios.post(url, { password, passwordConfirm, phoneNumber: "" });
};
export const ChangePasswordApi = (data: any) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const url = `${GURL}/Authentication/v1/Users/ChangePassword`;
  return axios.post(url, data);
};

export const CheckConfirm = (
  phoneNumber: any,
  Code: any,
  InvitationCode: any
) => {
  const url = `${GURL}/Authentication/v1/Users/ConfirmRequestVerificationCode`;
  return axios.post(url, { phoneNumber, Code, InvitationCode });
};

export const RegisterUser = (a: any, b: any) => {
  //console.log("sss");

  const url = `${GURL}/Authentication/v1/Users/Create`;

  return axios.post(url, { password: a, passwordConfirm: b });
};

export const SignIn = (phoneNumber: any, password: any) => {
  const url = `${GURL}/Authentication/v1/Users/SignIn`;
  return axios.post(url, { phoneNumber, password });
};
export const CreateUserAndProfile = (model: any) => {
  const url = `${GURL}/Authentication/v1/Users/CreateUserAndProfile`;
  return axios.post(url, model);
};

export const CheckUserExistByMobile = (mobile: string) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const url = `${GURL}/Authentication/v1/Users/UserExistByMobile?phoneNumber=${mobile}`;
  return axios.get(url);
};

export const GetUserByPhoneNumber = (mobile: string) => {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const url = `${GURL}/Authentication/v1/Users/GetUserByPhoneNumber?phoneNumber=${mobile}`;
  return axios.get(url);
};
